var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TrackerPermissionsModal,{ref:"trackerPermissionsModal",on:{"save":_setup.savePermissions}})
}
var staticRenderFns = []

export { render, staticRenderFns }